import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/shallow';

import {
  INVENTORY_DATE_SIZE,
  InventoryTabItemName,
  inventoryStore,
} from '../InventoryStore';

export const useRowState = (entityType: InventoryTabItemName) => {
  const { timePeriod, inventoryRooms, inventoryExperiences, inventoryPacks } =
    useStore(
      inventoryStore,
      useShallow((state) => ({
        timePeriod: state.timePeriod,
        inventoryRooms:
          entityType === InventoryTabItemName.Rooms
            ? state.inventoryRooms
            : undefined,
        inventoryExperiences:
          entityType === InventoryTabItemName.Experiences
            ? state.inventoryExperiences
            : undefined,
        inventoryPacks:
          entityType === InventoryTabItemName.Packs
            ? state.inventoryPacks
            : undefined,
      }))
    );

  const dateKeys = useMemo(
    () =>
      Array.from({ length: INVENTORY_DATE_SIZE }, (_, i) =>
        dayjs(timePeriod.startDate).add(i, 'day').format('YYYY-MM-DD')
      ),
    [timePeriod.startDate]
  );

  return {
    dateKeys,
    inventoryRooms,
    inventoryExperiences,
    inventoryPacks,
  };
};
